import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import loadjs from 'loadjs';
import { CARD_PAYMENT_METHODS } from '../../../../constants/CardPaymentMethod';

import CardinalClient from '../../adapters/CardinalClient';

import './LivePaymentPageComponent.scss';

class LivePaymentPageComponent extends Component {
  componentDidMount() {
    const { store } = this.props;

    if (
      (CARD_PAYMENT_METHODS.includes(store.source.type) &&
        store.source.redirect.provider_auth_url) ||
      store.source.type === 'three_d_secure'
    ) {
      if (store.authenticatedPayer) {
        store.setPageLoading(true);

        const client = new CardinalClient(store);

        loadjs(process.env.REACT_APP_CARDINAL_JS_URL, client.initialize);
      } else {
        store.fail();
      }
    }
  }

  render() {
    const { store } = this.props;
    let sourceElement = null;

    if (![...CARD_PAYMENT_METHODS, 'three_d_secure'].includes(store.source.type)) {
      sourceElement = (
        <p className="SubHead">
          Source&nbsp;
          <span>{store.source.id}</span>
          &nbsp;is not applicable for processing.
        </p>
      );
    }

    return (
      <div className="live-payment-page">
        {sourceElement}
        <div id="visible-wrapper" />
        <div id="hidden-wrapper" />
      </div>
    );
  }
}

LivePaymentPageComponent.propTypes = {
  store: PropTypes.shape({
    authenticatedPayer: PropTypes.bool,
    source: PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      status: PropTypes.string,
      card_device_data_collection: PropTypes.shape({
        access_token: PropTypes.string,
        provider_id: PropTypes.string,
        url: PropTypes.string
      }),
      redirect: PropTypes.shape({
        auth_token: PropTypes.string,
        provider_auth_id: PropTypes.string,
        provider_auth_url: PropTypes.string,
        provider_transaction_id: PropTypes.string,
        reference_id: PropTypes.string
      })
    }),
    charge: PropTypes.func.isRequired,
    fail: PropTypes.func.isRequired,
    setPageLoading: PropTypes.func.isRequired
  }).isRequired
};

export default inject(stores => {
  return {
    store: stores.store.source
  };
})(observer(LivePaymentPageComponent));
